<template>
    <div id="new">
        <h1 class="ui header">
            <!-- 新增客戶合約 -->
            {{ $t('ui.page_titles.new_contract') }}
        </h1>
        <div class="ui divider"></div>
        <div class="ui form">
            <div class="ui grid" style="margin-top:0margin-bottom:0">
                <div class="eight wide field" data-column="name">
                    <label>{{ $t('models.attributes.customer_contracts.name') }}</label>
                    <input
                        type="text"
                        v-model="contract.name">
                </div>
                <div class="eight wide field" data-column="number">
                    <label>{{ $t('models.attributes.customer_contracts.number') }}</label>
                    <input
                        type="text"
                        v-model="contract.number">
                </div>
                <div class="eight wide field" data-column="carrier_class">
                    <label>{{ $t('models.attributes.customer_contracts.carrier_class') }}</label>
                    <select v-if="$store.state.provider.node" class="ui dropdown" v-dropdown v-model="contract.carrier_class">
                        <option value="">{{ $t('ui.general.please_select') }}</option>
                        <option :value="$store.state.provider.node.carrier_class">{{ $store.state.provider.node.company_short_name }}</option>
                        <option value="Carrier::LMSProxy">自動轉運</option>
                    </select>
                    <div v-else class="ui inline active loader"></div>
                </div>

                <div class="eight wide field">
                    <label>{{ $t('models.attributes.customer_contracts.proxy_contract') }}</label>
                    <select v-if="current_store.provider_contracts" class="ui dropdown" v-dropdown v-model="contract.proxy_contract_identity">
                        <option value="">{{ $t('ui.general.please_select') }}</option>
                        <option v-for="provider_contract in current_store.provider_contracts" :value="provider_contract.identity">{{ provider_contract.name }}</option>
                    </select>
                    <div v-else class="ui inline active loader"></div>
                </div>
                <div class="ui horizontal divider"><h3><i class="code icon"></i>
                    <!-- 額外資訊 -->
                    {{ $t('ui.pages.customer_contracts.additional_information') }}
                </h3></div>
                <div class="sixteen wide red field">
                    <label>{{ $t('models.attributes.customer_contracts.note') }}</label>
                    <textarea v-model="contract.note" rows="4"></textarea>
                </div>
                <div class="sixteen wide field">
                    <label>{{ $t('models.attributes.customer_contracts.third_party_api_data') }}</label>
                    <textarea v-model="third_party_api_data" rows="4"></textarea>
                </div>
            </div>

            <div class="ui divider"></div>

            <div class="ui buttons">
                <a href="#" @click.prevent="$router.go(-1)" class="ui button">
                    {{ $t('ui.general.back') }}
                </a>
                <div class="or"></div>
                <a href="#" v-if="!is_loading" @click.prevent="create_contract()" class="ui blue button">
                    {{ $t('ui.general.create') }}
                </a>
                <a href="#" v-else class="ui blue button">
                    {{ $t('ui.general.creating') }}...
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Validator from '@toolbox/validator/main.js'

export default {
    name: "ProviderCustomersContractsNew",
    mixins: [
        Validator
    ],
    props: {
    },
    data() {
        return {
            is_loading: false,
            contract: {
                customer_identity: this.$route.params.customer_identity
            },
            third_party_api_data: ""
        }
    },
    mounted() {
    },
    watch: {
    },
    methods: {
        create_contract() {
            if (this.valid()) {
                this.is_loading = true

                this.contract.third_party_api_data = JSON.parse(this.third_party_api_data)
                var params = this.contract
                var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_contracts_create).parse()

                return axios.post(url, params, { headers: { Authorization: localStorage.getItem("authentication_token") }}).then(response => {
                    if (response.data.status == "success") {
                        // this.$noty.success("建立客戶合約成功")
                        this.$noty.success(
                            this.$t('ui.notifications.success.create__name', {
                                name: this.$t('models.contracts')
                            })
                        )
                        this.$router.push('/provider/customers')
                        this.is_loading = false
                    } else {
                        // this.$noty.error("建立客戶合約失敗")
                        this.$noty.error(
                            this.$t('ui.notifications.error.create__name', {
                                name: this.$t('models.contracts')
                            })
                        )
                        this.is_loading = false
                    }
                })
                .catch(error => {
                    // this.$noty.error("建立客戶合約失敗")
                    this.$noty.error(
                        this.$t('ui.notifications.error.create__name', {
                            name: this.$t('models.contracts')
                        })
                    )
                    this.is_loading = false
                })
            }
        }
    },
    validator: {
        target: "contract",
        localize_key: "contracts",
        input_alert: true,
        attributes: [
            {
                name: "name",
                required: true
            },
            {
                name: "number",
                required: true
            },
            {
                name: "carrier_class",
                required: true
            }
        ]
    },
    computed: {
        current_store() {
            return this.$store.state.provider.customers_module
        }
    },
    components: {
    }
}
</script>

<style lang="scss">
.ui.horizontal.divider:after, .ui.horizontal.divider:before {
    top: 0
}
</style>
